export default "__VITE_ASSET__f5e27229__"